import dotenv from 'dotenv';
dotenv.config();
import Vue from 'vue';
import './sentry';
import './firebase';
import Clipboard from 'v-clipboard';

import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import { apolloProvider } from '@/graphql';

// CSS
import vuetify from './plugins/vuetify';
import './assets/styles/tailwind.css';
import '@mdi/font/css/materialdesignicons.css';
import 'vue-cal/dist/vuecal.css';

Vue.config.productionTip = false;
Vue.use(Clipboard);

new Vue({
	router,
	store,
	apolloProvider,
	vuetify,
	render: h => h(App),
}).$mount('#app');
